import DataGrid from 'components/DataGrid';
import { useWithdrawTicket } from '../../hooks/useWithdrawTicket';
import RenderCellPopoverUpdate from '../components/RenderCellPopoverUpdate';
import { Grid } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import { TextBoxItem } from 'components/Input/TextBox';
import { useMemo, useState } from 'react';

const WithdrawTicketList = ({ isSwitch,isPermission }) => {

    //#region Hook
    const {
        dataColumnGettingTicket,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        anchorEl,
        setAnchorEl,
        messagePopper,
        formSearch,
        lstOptionMuseum,
        nPrmUser,
        nUserType,
        handleClearSearch,
    } = useWithdrawTicket(isSwitch,isPermission)
    // #endregion
    const [startDate, setStartDate] = useState(null);

    const dataColumn = useMemo(() => {
        let data = dataColumnGettingTicket;
        if (nUserType === 1) {
            data.splice(3, 1);
        }
        return data;
    }, [dataColumnGettingTicket, nUserType])

    return (
        <>
            <Grid container spacing={1} justifyContent={'flex-start'}>
                <Grid item xs={12} >
                    <FormProvider {...formSearch}>
                        <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextBoxItem
                                    name="sReceiveName"
                                    label={"ชื่อผู้ขอเบิก"}
                                    maxLength={10}
                                    id={"sReceiveName"}
                                    type={'text'}
                                    IsShowTextCont={false}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextBoxItem
                                    name="sOrderTicket"
                                    label={"เลขที่ใบเบิก"}
                                    maxLength={10}
                                    id={"sOrderTicket"}
                                    type={'text'}
                                    IsShowTextCont={false}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <DatePickerItem
                                    id={`nStartDate`}
                                    name={`nStartDate`}
                                    label={`วันที่เบิกตั๋ว (เริ่มต้น)`}
                                    fullWidth
                                    onChange={(e) => {
                                        setStartDate(e);
                                        if (e) {
                                            formSearch.setValue("sDateEnd", null);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <DatePickerItem
                                    id={`nEndDate`}
                                    name={`nEndDate`}
                                    label={`วันที่เบิกตั๋ว (สิ้นสุด)`}
                                    minDate={startDate}
                                    fullWidth
                                    disabled={false}
                                />
                            </Grid>
                            {nUserType !== 1 && nPrmUser === 2 && <Grid item xs={12} sm={12} md={3}>
                                <MultipleSelectItem
                                    id={"arrMuseumId"}
                                    name={"arrMuseumId"}
                                    label={`ชื่อพิพิธภัณฑ์`}
                                    required={false}
                                    options={lstOptionMuseum}
                                    limitTag={1}
                                />
                            </Grid>}
                            <Grid item xs={12} md={'auto'}>
                                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                    <Grid item>
                                        <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                    </Grid>
                                    <Grid item>
                                        <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>
                <Grid item xs={12} >
                    <DataGrid
                        columns={dataColumn}
                        isShowCheckBox={isPermission && dataRow.arrRows.length !== 0}
                        rows={dataRow}
                        isLoading={loadingTable}
                        onLoadData={getTable}
                        isHiddenFooter={dataRow.arrRows.length === 0}
                        onDelete={onDelete}
                        sTableID='gtWithdraw'
                        isHiddenToolHead
                        onRowSelectable={(p) => p.row.isAllowDelete}
                    />
                </Grid>
            </Grid>
            <RenderCellPopoverUpdate
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                MessagePopper={messagePopper}
            />
        </>

    )
}

export default WithdrawTicketList
